import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles( () => ( {
	breadcrumbs: {
		'& li': {
			display: 'block',
			marginBottom: 0
		}
	}
} ) )
